import { render, staticRenderFns } from "./EditStudentContent.vue?vue&type=template&id=67430175&scoped=true&"
import script from "./EditStudentContent.vue?vue&type=script&lang=ts&"
export * from "./EditStudentContent.vue?vue&type=script&lang=ts&"
import style0 from "./EditStudentContent.vue?vue&type=style&index=0&id=67430175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67430175",
  null
  
)

export default component.exports